import {Divider} from '@/components/ui/divider/Divider'
import {ProjectFormNewProjectSection} from '@/features/projects/components/project-form/project-form-new-project-section/ProjectFormNewProjectSection'
import {ProjectFormPatientSection} from '@/features/projects/components/project-form/project-form-patient-section/ProjectFormPatientSection'
import {ProjectFormReferenceSection} from '@/features/projects/components/project-form/project-form-reference-section/ProjectFormReferenceSection'
import {ProjectFormReferringSpecialistSection} from '@/features/projects/components/project-form/project-form-referring-specialist-section/ProjectFormReferringSpecialistSection'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {useFormContext, useWatch} from 'react-hook-form'
import {useOutletContext} from 'react-router-dom'
import {z} from 'zod'

const EarlyClosingProjectFormSectionsSchema = ProjectFieldsSchema.pick({
    hasReopening: true
})
type EarlyClosingProjectFormSectionsSchema = z.infer<typeof EarlyClosingProjectFormSectionsSchema>

export const EarlyClosingProjectFormSections = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {control} = useFormContext<EarlyClosingProjectFormSectionsSchema>()
    const hasReopening = useWatch({control, name: 'hasReopening'})
    return (
        <>
            <ProjectFormPatientSection showPatientSelect={false} patientId={project?.patientId} />
            <Divider direction="horizontal" />
            <ProjectFormReferenceSection isAllowed editingOperation="variation" />
            {hasReopening && (
                <>
                    <Divider direction="horizontal" />
                    <ProjectFormNewProjectSection editingOperation="variation" />
                    <Divider direction="horizontal" />
                    <ProjectFormReferringSpecialistSection />
                </>
            )}
        </>
    )
}
